import {
  TextAlign,
  TextDecoration,
  TextSize,
  TextTransform,
  TextWeight,
} from './GenericText.types';

export const sizeClasses = {
  [TextSize.XS]: 'text-xs',
  [TextSize.SM]: 'text-sm',
  [TextSize.BASE]: 'text-base',
  [TextSize.LG]: 'text-lg',
  [TextSize.XL]: 'text-xl',
  [TextSize.XXL]: 'text-2xl',
  [TextSize.XXXL]: 'text-3xl',
  [TextSize.XXXXL]: 'text-4xl',
  [TextSize.HERO]: 'text-hero md:text-d-hero',
  [TextSize.H1]: 'text-h1 md:text-d-h1',
  [TextSize.H2]: 'text-h2 md:text-d-h2',
  [TextSize.H3]: 'text-h3 md:text-d-h3',
  [TextSize.H4]: 'text-h4 md:text-d-h4',
};

export const weightClasses = {
  [TextWeight.LIGHT]: 'font-light',
  [TextWeight.NORMAL]: 'font-normal',
  [TextWeight.MEDIUM]: 'font-medium',
  [TextWeight.SEMIBOLD]: 'font-semibold',
  [TextWeight.BOLD]: 'font-bold',
  [TextWeight.EXTRABOLD]: 'font-extrabold',
};

export const alignClasses = {
  [TextAlign.LEFT]: 'text-left',
  [TextAlign.CENTER]: 'text-center',
  [TextAlign.RIGHT]: 'text-right',
  [TextAlign.JUSTIFY]: 'text-justify',
};

export const transformClasses = {
  [TextTransform.NORMAL]: 'normal-case',
  [TextTransform.UPPERCASE]: 'uppercase',
  [TextTransform.LOWERCASE]: 'lowercase',
  [TextTransform.CAPITALIZE]: 'capitalize',
};

export const decorationClasses = {
  [TextDecoration.NONE]: 'no-underline',
  [TextDecoration.UNDERLINE]: 'underline',
  [TextDecoration.LINE_THROUGH]: 'line-through',
};

export const letterSpacingClasses = {
  tighter: 'tracking-tighter',
  tight: 'tracking-tight',
  normal: 'tracking-normal',
  wide: 'tracking-wide',
  wider: 'tracking-wider',
  widest: 'tracking-widest',
};
